import { requiredDateMessage } from "../validationMessages";
import { dateValidator as dateValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

export const minDate: Date = new Date(1900, 1, 1);
export const maxDate: Date = new Date();

export const dateValidatorRequired = trimmedString
  .typeError(requiredDateMessage)
  .required(requiredDateMessage)
  .matches(dateValidatorRegex, requiredDateMessage);
export const dateValidator = trimmedString
  .nullable()
  .matches(dateValidatorRegex, {
    message: requiredDateMessage,
    excludeEmptyString: true,
  });
